import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {resetErrorMessage} from '../actions';
import {Link} from 'react-router';
import {loadDemoList, handleViewportResize, filterDemoList, toggleNaviTree, expandNaviTree, updateUserLang} from '../actions';
import NaviTreeView from '../components/NaviTreeView';
import SearchBar from '../components/SearchBar';
import Footer from '../components/Footer';
import {toggleClass} from '../utils/domUtils';
import {removeClass} from '../utils/domUtils';
import {addClass} from '../utils/domUtils';
import {version} from '../utils/domUtils';
import _ from 'lodash';
import {config, demos, examples} from '../../.temp/asset';
import TranslationProvider from '../../i18n/TranslationProvider';

import translate from '../../i18n/translate';

const DownloadTrial = 'DownloadTrial',OpenInNewWindow = 'OpenInNewWindow',NavigateToPreviousDemo = 'NavigateToPreviousDemo',NavigateToNextDemo = 'NavigateToNextDemo';

class App extends Component {
    constructor(props) {
        super(props);
        //this.loadDemos = this.loadDemos.bind(this);
        this.handleResize = this.handleResize.bind(this);
    }

    findCurrentDemoIndex(demoList) {
        let i;
        let len;
        const demos = this.getDemos(demoList);
        const currentDemoId = this.props.params.demoId;
        for(i = 0, len = demos.length; i < len; i++) {
            if(demos[i].id === currentDemoId) {
                return i;
            }
        }
        return -1;
    }

    getCurrentRoute() {
        var rootUrl = 'https://www.grapecity.co.kr/spreadjs/';
        if (process.env.LOCALE === 'cn') {
            rootUrl = 'http://www.gcpowertools.com.cn/products/spreadjs/';
        }
        var route = [{
            title: 'SpreadJS',
            path: rootUrl
        }, {
            title: 'Spread.Sheets',
            path: '#'
        }];
        var href = window.location.href;
        var index = href.toLowerCase().lastIndexOf('quickstart/');
        if(index > 0) {
            route.push({
                title: 'QuickStart',
                path: href
            })
        }
        index = href.toLowerCase().lastIndexOf('#/demos/');
        if (index > 0) {
            var demoId = href.slice(index + '#/demos/'.length);
            if (demoId) {
                route.push({
                    title: demoId,
                    path: href
                });
            }
        }
        index = href.toLowerCase().lastIndexOf('#/examples/');
        if (index > 0) {
            var demoId = href.slice(index + '#/examples/'.length);
            if (demoId) {
                route.push({
                    title: demoId,
                    path: href
                });
            }
        }
        return route;
    }

    getDemos(demoList) {
        if (!demoList) {
            return;
        }
        if (demoList[0].children) {
            var demos = this.getDemos(_.flatten(_.map(demoList, _.property('children'))));
        } else {
            return demoList;
        }
        if (demos) {
            return demos;
        }
    }

    handleNavigateInteranl(forward) {
        let self = this;
        let demoList;
        let groupName;
        let treeState = [], i = 0;
        if(this.props.location.pathname.toLowerCase().indexOf('demos/') > 0) {
            demoList = this.props.demos;
            groupName = 'demos';
        } else {
            demoList = this.props.examples;
            groupName = 'examples';
        }
        const demos = self.getDemos(demoList);
        let currentIndex = self.findCurrentDemoIndex(demoList);
        let condition = forward ? (currentIndex >= 0 && currentIndex < demos.length - 1) : (currentIndex > 0);
        if(condition) {
            currentIndex += (forward ? 1 : -1);
            treeState = this.props.getTreeNodeKey(demos[currentIndex].id, groupName === "examples" ? "2" : "3", demoList);
            while(i < treeState.length) {
                self.props.expandNaviTree(treeState[i]);
                i++;
            }
            self.props.history.pushState(null, (groupName === 'demos' ? '/demos/' : '/examples/') + demos[currentIndex].id);
        }
    }

    handleNavigateToNextBtnClick(e) {
        this.handleNavigateInteranl(true);
    }

    handleNavigateToPreviousClick(e) {
        this.handleNavigateInteranl(false);
    }

    handleNewWindowBtnClick(e) {
        var index = this.props.location.pathname.toLowerCase().indexOf('demos/');
        if(index > 0) {
            window.open('demos/' + this.props.params.demoId + '.html', "_blank");
        } else {
            window.open('examples/' + this.props.params.demoId + '.html', "_blank");
        }
    }

    handleResize() {
        this.props.handleViewportResize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }

    handleUserlangChange() {
        var e = document.getElementById("languageChooser");
        var lang = e.options[e.selectedIndex].value;
        this.props.updateUserLang(lang);
    }

    handleUserlangChangeToCn(e) {
        this.props.updateUserLang('cn');
    }

    handleRotate() {
        this.props.handleViewportResize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }

    handleClick(key) {
        this.props.toggleNaviTree(key);
    }

    componentWillMount() {
        this.handleResize();
    }

    showNavigationButtons() {
        if (this.props.routes.length > 2) {
            $('.btn-groups').removeClass('hide');
        } else {
            $('.btn-groups').addClass('hide');
        }
    }

    componentDidMount() {
        this.showNavigationButtons();
        window.addEventListener('resize', this.handleResize);
        var userAgent = navigator.userAgent;
        var regex = /iPad|iPhone|Android/i;
        var isTouchDevice = (regex.test(userAgent)) && (window.screen.width <= 768 || window.screen.height <= 768);
        if (isTouchDevice) {
            var wrapperElement = document.getElementById('wrapper');
            // removeClass(wrapperElement, 'toggled');

            addClass(wrapperElement, 'mobile');
            removeClass(wrapperElement, 'desktop');

            // var searchBar = document.querySelector('#wrapper .search');
            // addClass(searchBar, 'hide');
        }
        window.addEventListener('orientationchange', this.handleRotate.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize.bind(this));
        window.removeEventListener('orientationchange', this.handleRotate.bind(this));
    }

    componentDidUpdate() {
        this.showNavigationButtons();
    }

    handleSidebarToggle(e) {
        e.preventDefault();

        var wrapperElement = document.getElementById('wrapper');
        toggleClass(wrapperElement, 'toggled');

        var searchBar = document.querySelector('#wrapper .search');
        toggleClass(searchBar, 'hide');
    }

    treeViewItemClick() {
        var mainContent = document.getElementsByClassName('mainContent')[0];
        if (mainContent) {
            mainContent.scrollTo(0, 0);
        }
    }

    render() {
        const {demos, examples, filterDemoList, strings} = this.props;
        //TODO: refactoring later, just hard code now.
        let dataSource = [
            {title: 'Home', path: '/', children: []},
            {title: 'Quick Start', path: '/quickstart/', children: []},
            {title: 'Demo Gallery', path: '/examples/', children: []},
            {title: 'Feature Samples', path: '/demos/', children: []},
        ];

        const countries = [
            {value: 'en', label: 'English'},
            {value: 'cn', label: '中文'},
            {value: 'jp', label: '日文'}
        ];

        if (demos) {
            dataSource[2].children = examples;
            dataSource[3].children = demos;
        }

        let routes = this.getCurrentRoute();

        return (
            <TranslationProvider>
                <div id="sidebar-wrapper">
                    <div className="sidebar-head">
                        <div className="toolbar">
                            <div className="toolbar-section toolbar-section--left">
                                <div className="logo"><h1></h1></div>
                            </div>
                            <div className="toolbar-section toolbar-section--right">
                                <div className="action hidden-desktop" role="button" onClick={e=>this.handleSidebarToggle(e)}>
                                    <svg fill="currentColor" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                                        <path d="M0 0h24v24H0z" fill="none"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <SearchBar onValueChaged={filterDemoList}/>
                    <div className="tree-view-container">
                        <NaviTreeView treeCollapsedKeeping={this.props.treeCollapsedKeeping}
                                      onClick={this.handleClick.bind(this)} treeViewItemClick={this.treeViewItemClick.bind(this)} dataSource={dataSource}/>
                    </div>
                </div>
                <div className="site-overlay" onClick={e=>this.handleSidebarToggle(e)}>
                </div>
                <div id="page-content-wrapper">
                    <nav id="titleNav" className="toolbar navbar navbar-default navbar-fixed-top">
                        <div className="toolbar-section toolbar-section--left">
                            <div className="action hidden-desktop" role="button" onClick={e=>this.handleSidebarToggle(e)}>
                                <svg fill="currentColor" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 0h24v24H0z" fill="none"/>
                                    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
                                </svg>
                            </div>
                            <ul className="breadcrumb">
                                {routes.map((item, index) =>
                                    <li key={index}>
                                        <a href={item.path || ''}>
                                            {item.title }
                                        </a>
                                    </li>
                                )}
                            </ul>
                        </div>
                        <div className="toolbar-section toolbar-section--right">
                            <div className="btn-groups pull-right hidden-mobile">
                                <a role="button" target="_blank" className="btn btn-newWindow"
                                   title="Open in new window"
                                   onClick={(e) => this.handleNewWindowBtnClick(e)}>
                                    <i className="fa fa-external-link" />
                                </a>
                                <a role="button" className="btn btn-previous"
                                   title="Navigate to previous demo"
                                   onClick={(e) => this.handleNavigateToPreviousClick(e)}>
                                    <i className="fa fa-long-arrow-left"/>
                                </a>
                                <a role="button" className="btn btn-next" title="Navigate to next demo"
                                   onClick={(e) => this.handleNavigateToNextBtnClick(e)}>
                                    <i className="fa fa-long-arrow-right" />
                                </a>
                            </div>
                            <div className="sample-download-free">
                                <a href="https://www.grapecity.co.kr/download/spreadjs" className="sample-header-download" target="_blank">
                                    <span>Download Trial</span>
                                </a>
                            </div>
                        </div>
                    </nav>
                    <div className="content">
                        {this.props.children}
                    </div>
                    <Footer handleUserlangChange={this.handleUserlangChange.bind(this)}/>
                </div>
            </TranslationProvider>
        );
    }
}

App.propTypes = {
    demos: PropTypes.array,
    handleViewportResize: PropTypes.func
};

function getDemoList(state, groupName) {
    const {filterString} = state;
    const filter = filterString && filterString.filter && filterString.filter.toLowerCase();

    var demoList = groupName === "demos" ? demos.demoList : examples.demoList;
    if (filter) {
        var result = getDemoItems(filter, demoList);
        if (result.length <= 0) {
            _.each(demoList, function (group) {
                var itemResult = getDemoItems(filter, group.children);
                if(itemResult.length > 0) {
                    result.push({
                        title: group.title,
                        id: group.id,
                        children: itemResult
                    });
                }
            })
        }
        return result;
    }
    return demoList;
}


function getDemoItems(filter, group) {
    var itemResult = [];
    var filteredGroupItmes = _.filter(group, function (item) {
        return item.title.toLowerCase().indexOf(filter) >= 0 || (item.keywords && _.find(item.keywords, function (keyword) {
                return keyword.toLowerCase().indexOf(filter) >= 0;
            }));
    });

    if (filteredGroupItmes.length > 0) {
        return filteredGroupItmes;
    }

    _.each(group, function (subGroup) {
        var filteredGroupItmes = _.filter(subGroup.children, function (item) {
            return item.title.toLowerCase().indexOf(filter) >= 0 || (item.keywords && _.find(item.keywords, function (keyword) {
                    return keyword.toLowerCase().indexOf(filter) >= 0;
                }));
        });

        if (filteredGroupItmes.length > 0) {
            itemResult.push({
                title: subGroup.title,
                id: subGroup.id,
                level: subGroup.level,
                children: filteredGroupItmes
            });
        }
    })
    return itemResult;
}

function getTreeNodeKey(treeId, level, demoList) {
    var nodeLevel = getTreeNodeLevel(treeId, demoList);
    if(nodeLevel) {
        var treeNode = ["level0_" + level + nodeLevel];
        var nodes = nodeLevel.split('_');
        for (var i = 0; i < nodes.length; i++) {
            if(nodes.length > 2) {
                nodes.pop();
                nodeLevel = nodes.join('_');
                treeNode.push("level0_" + level + nodeLevel);
                nodes = nodeLevel.split('_');
            }
        }
        return treeNode;
    }
    return null;
}

function getTreeNodeLevel (treeId, demos) {
    if(!demos) {
        return ;
    }
    if(demos.length > 0) {
        for(var i = 0; i < demos.length; i++) {
            if(demos[i].children) {
                var result = getTreeNodeLevel(treeId, demos[i].children);
            } else {
                var filterdGroupItems = _.filter(demos, function(item) {
                    return item.id.toLowerCase() === treeId.toLowerCase();
                });
                if (filterdGroupItems.length > 0) {
                    return '_' + i.toString();
                }
                return false;
            }
            if (result) {
                return '_' + i.toString() + result;
            }
        }
    }
}

function getTreeCollapseKeeping(state) {
    const {filterString, updateNaviTree} = state;
    var tree = updateNaviTree.naviTreeCollapsed;
    var treeState = [], i = 0;
    if (_.isEmpty(tree)) {
        var href = window.location.href;
        var index = href.toLowerCase().lastIndexOf('#/demos/'), groupName = 'demos', offset = '#/demos/'.length, demoList = demos.demoList;
        if (index === -1) {
            index = href.toLowerCase().lastIndexOf('#/examples/');
            demoList = examples.demoList;
            groupName = "examples";
            offset = '#/examples/'.length;
        }
        if (index > 0) {
            groupName === "examples" ? tree['level0_2'] = false : tree['level0_3'] = false;
            var demoId = href.slice(index + offset);
            if (demoId) {
                treeState = getTreeNodeKey(demoId, groupName === "examples" ? "2" : "3", demoList);
                while(i < treeState.length) {
                    tree[treeState[i]] = false;
                    i++;
                }
            }
        }
    }
    if (filterString) {
        const {filter, oldFilter} = filterString;
        if (filter !== '' && filter !== oldFilter) {
            _.each(tree, function (value, key) {
                tree[key] = true;
            })
            tree['level0_2'] = false;
            var list = getDemoList(state, "examples");
            _.each(list, function (demo, index) {
                tree['level0_2_' + index] = false;
            });
            tree['level0_3'] = false;
            list = getDemoList(state, "demos");
            _.each(list, function (demo, index) {
                tree['level0_3_' + index] = false;
                _.each(demo.children, function (item, temp) {
                    tree['level0_3_' + index + '_'  + temp] = false;
                });
            })
        }
    }
    return tree;
}

const stateToProps = state => ({
    demos: getDemoList(state, 'demos'),
    examples: getDemoList(state, 'examples'),
    treeCollapsedKeeping: getTreeCollapseKeeping(state),
    getTreeNodeKey: getTreeNodeKey,
});

App.defaultProps = {
    strings: {}
};

const decorators = _.flow([
    connect(stateToProps, {handleViewportResize, filterDemoList, toggleNaviTree, expandNaviTree, updateUserLang}),
]);

export default translate('App')(decorators(App));



// WEBPACK FOOTER //
// ./client/containers/App.js